import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaTools, FaClock } from 'react-icons/fa';
import './MaintenanceMode.css';

const MaintenanceMode = ({ message }) => {
  return (
    <div className="maintenance-mode-page">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={8} lg={6}>
            <Card className="maintenance-card">
              <Card.Body className="text-center p-5">
                <div className="maintenance-icon">
                  <FaTools size={80} />
                </div>
                <h1 className="maintenance-title">We'll Be Right Back!</h1>
                <div className="maintenance-message">
                  <p>
                    {message || 'We are currently performing maintenance to improve your experience. Please check back soon.'}
                  </p>
                </div>
                <div className="maintenance-clock">
                  <FaClock size={24} />
                  <span className="ms-2">Expected duration: A few moments</span>
                </div>
                <div className="maintenance-contact mt-4">
                  <p className="text-muted">
                    For urgent matters, please contact us at <a href="mailto:sales@trventilation.com">sales@trventilation.com</a>
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default MaintenanceMode;
